import CommonModal from "../modalLayout/CommonModal";

const ConfirmationModal = ({
  show,
  setShow,
  message,
  onConfirm,
  onCancel,
  isLoading,
  icon: Icon,
  iconProps,
}) => {
  return (
    <CommonModal
      className="modal-sm"
      show={show}
      setShow={setShow}
      centered
      title={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLoading={isLoading}
      footerOrder="cancel-first"
      footerAlign="center"
    >
      {Icon && (
        <div className="text-center mb-3">
          <Icon {...iconProps} />
        </div>
      )}
    </CommonModal>
  );
};

export default ConfirmationModal;
